import React, { createContext, useEffect, useReducer } from 'react'
import axios from 'axios.js'
import { MatxLoading } from 'app/components'
import { Apis } from 'app/Apis/Apis'
import { useNavigate } from 'react-router-dom'
import { Alert } from '@mui/material'
import { useState } from 'react'
import { StaticData } from 'app/utils/constant'
import { useDispatch, useSelector } from 'react-redux'
const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
}

const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload

            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
            }
        }
        case 'LOGIN': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'REGISTER': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => {},
    register: () => Promise.resolve(),
})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const [loading, setLoading] = useState()
    const reduxDispatch = useDispatch()
    const authData = useSelector((state) => state.authentication)
    const navigate = useNavigate()
    const login = async (email, password) => {
        console.log(email, password)

        await axios

            .post(`${Apis.loginApi}`, {
                email: email,
                password: password,
            })
            .then(function (response) {
                console.log('response.data.img', response.data.data)
                localStorage.setItem('accessToken', response.data.data.token)
                localStorage.setItem('userRole', response.data.data.role)
                if (response.status === 200) {
                    const user = {
                        email: response.data.data.email,
                        name: response.data.data.name,
                        role: response.data.data.role,
                        avatar:
                            response?.data?.data?.image ||
                            StaticData.profileImage,
                    }

                    let LOGGING = setInterval(() => {
                        navigate('/')
                    }, 1000)
                    reduxDispatch({ type: 'AUTHORIZE', payload: true })
                    setTimeout(() => {
                        clearInterval(LOGGING)
                    }, 2000)

                    setLoading(true)
                    dispatch({
                        type: 'LOGIN',
                        payload: {
                            user,
                        },
                    })
                } else {
                }
                localStorage.setItem(
                    'UserInfo',
                    JSON.stringify([
                        response?.data?.data?.name,
                        response?.data?.data?.image,
                    ])
                )
            })
            .catch(function (error) {
                setLoading(false)
                console.error('error=====>', error)
            })
    }
    const register = async (email, username, password) => {
        const response = await axios.post('/api/auth/register', {
            email,
            username,
            password,
        })

        const { accessToken, user } = response.data

        setSession(accessToken)

        dispatch({
            type: 'REGISTER',
            payload: {
                user,
            },
        })
    }

    const logout = () => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('userRole')

        localStorage.removeItem('UserInfo')
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }

    setTimeout(() => {
        setLoading(0)
    }, 4000)

    console.log('authData ', authData)

    useEffect(() => {
        localStorage.getItem('accessToken')
            ? reduxDispatch({ type: 'AUTHORIZE', payload: true })
            : console.log('')

        console.log('authData', ' in useeffect', authData)
    }, [])

    useEffect(() => {
        ;(async () => {
            try {
                const { data } = await axios.get('/api/auth/profile')
                dispatch({
                    type: 'INIT',
                    payload: { isAuthenticated: true, user: data.user },
                })
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: { isAuthenticated: false, user: null },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                login,
                logout,
                register,
            }}
        >
            {loading === true ? (
                <Alert
                    sx={{ position: 'absolute', width: '100%' }}
                    severity="success"
                >
                    Logging...
                </Alert>
            ) : (
                ''
            )}
            {loading === false ? (
                <Alert
                    sx={{ position: 'absolute', width: '100%' }}
                    severity="warning"
                >
                    Invalid email or password
                </Alert>
            ) : (
                ''
            )}
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
